<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load accounts"
    data-testid="warrants-accounts"
    searchable
    search-align-end
    search-placeholder="Search account number"
    row-clickable
    :filters="warrantsAccountsTableFilters"
    :fetcher="fetchAccounts"
    :items-from="itemsFrom"
    @row-click="onRowClick"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip
        :type="accountStateChipType(internalItem.raw.status)"
        :text="internalItem.raw.statusDisplay"
        size="small"
      />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"
  import {
    accountNumberColumn,
    createdAtColumn,
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsAccountListResult,
    WarrantsAccountService,
  } from "@/services/admin/WarrantsAccountService"
  import { accountStateChipType } from "@/views/admin/warrants/warrantStatusChip"
  import {
    warrantsAccountsTableFilters,
    WarrantsAccountsTableFilters,
  } from "@/views/admin/warrants/warrantsAccountsConfig"
  import { IWarrantsAccount } from "@/models/admin/warrantsAccount/warrantsAccount.types"
  import { RouteNames } from "@/types/router"

  const headers: SoDataTableHeader[] = [
    idColumn,
    accountNumberColumn,
    statusColumn,
    {
      title: "Paused",
      key: "isPaused",
      type: SoDataTableColumnType.YES_OR_NO,
      sortable: false,
    },
    createdAtColumn,
    // Calculated 'System' / 'Agent' / '' value from the domain model.
    { title: "Deleted", key: "deletedBy", sortable: false },
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
        warrantsAccountsTableFilters,
      }
    },
    methods: {
      accountStateChipType,
      fetchAccounts({
        search,
        filters,
        page,
        pageSize,
        orderBy,
      }: SoDataTableOptions<WarrantsAccountsTableFilters>) {
        return WarrantsAccountService.getAccounts(
          search,
          {
            status: filters.status.value,
            paused:
              filters.paused.value === null
                ? null
                : filters.paused.value === "true",
          },
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsAccountListResult) {
        return result.accounts
      },
      onRowClick(account: IWarrantsAccount) {
        this.$router.push({
          name: RouteNames.AdminServiceWarrantsCommunications,
          params: {
            serviceName: this.$route.params.serviceName,
            accountNumber: account.accountNumber,
          },
        })
      },
    },
  })
</script>
